<template>
    <div>
        <v-dialog v-model="isModalShowing" persistent max-width="700">
            <v-card class="py-5 custom-card">
                <v-card-title class="modal-text">
                    {{ $t("routesInfos.modalText") }}
                </v-card-title>
                <v-card-actions class="card-btn-wrapper">
                    <v-btn class="card-btn" @click="setLang('el')">
                        {{ $t("routesInfos.modalGreek") }}
                    </v-btn>

                    <v-btn class="card-btn" @click="setLang('en')">
                        {{ $t("routesInfos.modalEnglish") }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <desktop-view-new
            v-if="!$vuetify.breakpoint.mobile"
            :area="area"
            :announcements="announcements"
            :screen="screen"
            :routes="routes"
            :time="time"
            :check-window-size="checkWindowSize"
        />
        <mobile-view
            v-else
            :routes="routes"
            :announcements="announcements"
            :area="area"
        />
    </div>
</template>

<script>
    import routesService from '@/services/routes-service'
    import MobileView from '@/components/MobileView.vue'
    import DesktopViewNew from '@/components/DesktopViewNew.vue'
    import dummyData from '@/utils/dummyData'

    export default {
        name: 'RoutesInformations',
        components: { DesktopViewNew, MobileView },
        data() {
            return {
                time: '',
                date: '',
                week: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
                routes: [],
                area: {},
                announcements: [],
                screen: {},
                isMobile: false,
                checkWindowSize: true,
                isModalShowing: false
            }
        },
        computed: {
            mode() {
                return this.$store.getters.getMode
            }
        },
        watch: {
            $route(to, from) {
                if (from.params.screenId !== to.params.screenId) {
                    this.getScreenData()
                }
                this.$store.dispatch('setMode', to.query.mode)
                if (from.query.mode !== to.query.mode) {
                    this.initializeAutoMode(to.query.mode)
                } else if (this.mode !== 'auto') {
                    clearInterval(this.languageChangeInterval)
                    if (from.query.lang !== to.query.lang) {
                        this.setLang(to.query.lang)
                    }
                }
            }
        },
        beforeDestroy() {
            if (typeof window === 'undefined') {
                return window.removeEventListener('resize', this.onResize, {
                    passive: true
                })
            }
            clearInterval(this.languageChangeInterval)
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
            if (this.$route.query.mode === 'auto') {
                this.$store.dispatch('setMode', this.$route.query.mode)
                this.initializeAutoMode(this.$route.query.mode)
            } else if (
                !this.$store.getters.getAvailableLanguages.includes(
                    this.$route.query.lang
                )
            ) {
                this.isModalShowing = true
            } else if (this.$route.query.lang !== this.$store.getters.getLanguage) {
                this.$i18n.locale = this.$route.query.lang
                this.$store.dispatch('toggleLanguage', this.$route.query.lang)
            } else {
                this.isModalShowing = false
            }
        },
        created() {
            if (this.$vuetify.breakpoint.height !== 2160) {
                this.getScreenData()
            }
            setInterval(() => {
                this.getScreenData()
            }, 1 * 60 * 1000)
            setInterval(async() => {
                this.updateTime()
            }, 1000)
            this.updateTime()
        },
        methods: {
            initializeAutoMode(mode) {
                if (mode === 'auto') {
                    this.languageChangeInterval = setInterval(() => {
                        const nextLanguage =
                            this.$store.getters.getLanguage === 'el' ? 'en' : 'el'
                        this.$i18n.locale = nextLanguage
                        this.setLang(nextLanguage)
                        if (this.mode !== 'auto') {
                            clearInterval(this.languageChangeInterval)
                        }
                    }, 20 * 1000)
                } else {
                    clearInterval(this.languageChangeInterval)
                }
            },
            onResize() {
                this.isMobile = window.innerWidth < 1200
                window.innerWidth > 1920
                    ? (this.checkWindowSize = true)
                    : (this.checkWindowSize = false)
            },
            getScreenData() {
                if (process.env.VUE_APP_ENV === 'offline_development') {
                    this.area = dummyData.screen.area
                    this.routes = dummyData.routes
                    this.announcements = dummyData.announcements
                    this.screen = dummyData.screen
                    return
                }
                return routesService
                    .fetchAllMultilingualScreenDataBasedOnId(this.$route.params.screenId)
                    .then(data => {
                        this.area = data.screen.area
                        this.routes = data.routes
                        this.announcements = data.announcements
                        this.screen = data.screen
                    })
            },
            updateTime() {
                const cd = new Date()
                this.time =
                    this.zeroPadding(cd.getHours(), 2) +
                    ':' +
                    this.zeroPadding(cd.getMinutes(), 2) +
                    ':' +
                    this.zeroPadding(cd.getSeconds(), 2)
                this.date =
                    this.zeroPadding(cd.getFullYear(), 4) +
                    '-' +
                    this.zeroPadding(cd.getMonth() + 1, 2) +
                    '-' +
                    this.zeroPadding(cd.getDate(), 2) +
                    ' ' +
                    this.week[cd.getDay()]
            },

            setLang(lang) {
                const query = { lang }
                if (this.mode === 'auto') {
                    query.mode = this.mode
                }
                this.$router.push({
                    path: `/routesInfos/${this.$route.params.screenId}`,
                    query
                })
                this.$store.dispatch('toggleLanguage', lang)
                if (this.isModalShowing) {
                    location.reload()
                }
            },

            zeroPadding(num, digit) {
                let zero = ''
                for (let i = 0; i < digit; i++) {
                    zero += '0'
                }
                return (zero + num).slice(-digit)
            }
        }
    }
</script>

<style>
.v-overlay__scrim {
  opacity: 0.95 !important;
}
</style>

<style scoped>
.custom-card {
  background-color: #393939;
  color: #fff;
}

.modal-text {
  display: flex;
  justify-content: center;
  margin: 2rem 0;
  word-break: break-word !important;
  text-align: center;
}

.card-btn-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.card-btn {
  display: flex;
  justify-content: center;
  background-color: #ee7d11 !important;
  color: #fff;
  width: 150px !important;
  height: auto !important;
  padding: 0.8rem 1.5rem !important;
  margin: 0 !important;
}

@media screen and (min-width: 992px) {
  .modal-text {
    font-size: 1.3rem !important;
  }

  .card-btn-wrapper {
    flex-direction: row;
    justify-content: center;
    gap: 1rem;
  }
}
</style>
